module.exports = __webpack_public_path__ + "static/media/earth.2e48a051.png";